import { render, staticRenderFns } from "./StockThresholdsPanel.vue?vue&type=template&id=2ad4a67b&scoped=true&"
import script from "./StockThresholdsPanel.vue?vue&type=script&lang=js&"
export * from "./StockThresholdsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StockThresholdsPanel.vue?vue&type=style&index=0&id=2ad4a67b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4a67b",
  null
  
)

export default component.exports